// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ds-section-nav-bar{display:flex;flex-direction:column;background:#fff;z-index:1;padding:0px 20px;box-shadow:0px 4px 4px rgba(0,0,0,.05)}.ds-section-nav-bar.sticky{position:sticky;top:0px;z-index:600}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
